import {ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit} from "@angular/core";
import {DepotYard} from "../../../shared/view-model/store-management/depot-yard.type";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {FormBuilder, FormControl} from "@angular/forms";
import {appInjector} from "../../../index";
import {SessionActions} from "../../../shared/actions";

@Component({
  selector: 'vb-depot-yard-input',
  templateUrl: './depot-yard-input.component.html',
  styleUrls: ['./depot-yard-input.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => DepotYardInputComponent)}],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepotYardInputComponent extends AbstractVisbosControl<DepotYard, FormControl> implements OnInit {

  @Input()
  depotYards: DepotYard[];

  @Input()
  loading: boolean;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();

  }

  buildControlContent(): FormControl {
    return DepotYardInputComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormControl {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.control(null);
  }

  public setDefaultValues(item?: DepotYard): { [controlKey: string]: any } | any {
    return this.setValue(item, 'cuid');
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/depot/depot-yard-input/depot-yard-input.component.ts